import React from 'react';

import type { EventVisibility } from '../../../api/types';
import { clamp } from '../../../domain/events/time';
import { TavernField } from '../../../ui/components';

export type EventSettingsSectionProps = {
  maxParticipants: number;
  minMaxParticipants: number;
  maxParticipantsLimit: number;
  visibility: EventVisibility;
  isSubmitting: boolean;
  maxParticipantsError: string | null;
  onMaxParticipantsChange: (value: number) => void;
  onMaxParticipantsBlur: () => void;
  onVisibilityChange: (value: EventVisibility) => void;
};

export const EventSettingsSection = React.memo(function EventSettingsSection({
  maxParticipants,
  minMaxParticipants,
  maxParticipantsLimit,
  visibility,
  isSubmitting,
  maxParticipantsError,
  onMaxParticipantsChange,
  onMaxParticipantsBlur,
  onVisibilityChange,
}: EventSettingsSectionProps) {
  const handleDecrement = () => {
    onMaxParticipantsBlur();
    onMaxParticipantsChange(clamp(maxParticipants - 1, minMaxParticipants, maxParticipantsLimit));
  };

  const handleIncrement = () => {
    onMaxParticipantsBlur();
    onMaxParticipantsChange(clamp(maxParticipants + 1, minMaxParticipants, maxParticipantsLimit));
  };

  return (
    <div className="ttbFormSection">
      <div className="ttbFormSectionHeader">
        <span className="ttbFormSectionIcon">⚙️</span>
        <h2 className="ttbFormSectionTitle">Параметры приключения</h2>
      </div>

      <TavernField
        label="Максимум участников"
        required
        error={maxParticipantsError}
        hint={`От 2 до ${maxParticipantsLimit} участников`}
      >
        <div className={['ttbStepper', maxParticipantsError ? 'ttbStepperError' : null].filter(Boolean).join(' ')}>
          <button
            type="button"
            disabled={isSubmitting || maxParticipants <= minMaxParticipants}
            onClick={handleDecrement}
            className="ttbButton ttbStepperButton"
          >
            −
          </button>
          <div className="ttbStepperValue">{maxParticipants} человек</div>
          <button
            type="button"
            disabled={isSubmitting || maxParticipants >= maxParticipantsLimit}
            onClick={handleIncrement}
            className="ttbButton ttbStepperButton"
          >
            +
          </button>
        </div>
      </TavernField>

      <TavernField label="Статус доступа" required>
        <div className="ttbRadioGroup">
          <div className="ttbRadioOption">
            <input
              type="radio"
              id="visibility-open"
              name="visibility"
              value="open"
              checked={visibility === 'open'}
              disabled={isSubmitting}
              onChange={() => onVisibilityChange('open')}
            />
            <label htmlFor="visibility-open" className="ttbRadioLabel">
              <div className="ttbRadioIcon">🌍</div>
              <div className="ttbRadioText">OPEN</div>
              <div className="ttbRadioHint">Открыто для всех</div>
            </label>
          </div>
          <div className="ttbRadioOption">
            <input
              type="radio"
              id="visibility-private"
              name="visibility"
              value="private"
              checked={visibility === 'private'}
              disabled={isSubmitting}
              onChange={() => onVisibilityChange('private')}
            />
            <label htmlFor="visibility-private" className="ttbRadioLabel">
              <div className="ttbRadioIcon">🔒</div>
              <div className="ttbRadioText">Private</div>
              <div className="ttbRadioHint">По приглашению</div>
            </label>
          </div>
        </div>
      </TavernField>
    </div>
  );
});
